var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52859 0.195262C7.78895 -0.0650874 8.21105 -0.0650874 8.47141 0.195262L13.1381 4.86193C13.3984 5.12228 13.3984 5.54439 13.1381 5.80474C12.8777 6.06509 12.4556 6.06509 12.1953 5.80474L8.66667 2.27614V10.0417C8.66667 10.3868 8.36819 10.6667 8 10.6667C7.63181 10.6667 7.33333 10.3868 7.33333 10.0417V2.27614L3.80474 5.80474C3.54439 6.06509 3.12228 6.06509 2.86193 5.80474C2.60158 5.54439 2.60158 5.12228 2.86193 4.86193L7.52859 0.195262ZM0.666667 9.33333C1.03486 9.33333 1.33333 9.63181 1.33333 10V13.5556C1.33333 13.8681 1.44766 14.1573 1.63541 14.3622C1.82138 14.565 2.06055 14.6667 2.2963 14.6667H13.7037C13.9395 14.6667 14.1786 14.565 14.3646 14.3622C14.5523 14.1573 14.6667 13.8681 14.6667 13.5556V10C14.6667 9.63181 14.9651 9.33333 15.3333 9.33333C15.7015 9.33333 16 9.63181 16 10V13.5556C16 14.186 15.7709 14.8011 15.3475 15.2631C14.9222 15.727 14.3324 16 13.7037 16H2.2963C1.66764 16 1.0778 15.727 0.652538 15.2631C0.229055 14.8011 0 14.186 0 13.5556V10C0 9.63181 0.298477 9.33333 0.666667 9.33333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4bc94a84.svg";
export { ForwardRef as ReactComponent };